<template>
  <svg class="svg_component" width="0" height="0">
    <defs id="defs1">
      <pattern
          :id="'pattern18_'+color"
          :xlink:href="'#FloorTiles_'+color"
          preserveAspectRatio="xMidYMid"
          patternTransform="matrix(0.07071068,-0.07071068,0.07071068,0.07071068,0,0)"
          x="0"
          y="0"
      />
      <pattern
          :id="'FloorTiles_'+color"
          :fill="color"
          patternUnits="userSpaceOnUse"
          width="90"
          height="90"
          preserveAspectRatio="xMidYMid"
          patternTransform="rotate(-45)"
      >
        <path
            id="rect1"
            style="stroke-width:5;stroke-miterlimit:10"
            d="M 0,0 V 1 H 15 V 15 H 0 v 1 44 0.5 0.5 14 1 h 30 v 14 h 1 V 76 h 14 v 14 h 1 V 61 h 14 v 29 h 1 V 46 h 14 v 29 0.5 0.5 14 h 1 V 76 H 90 V 75 H 76 V 31 H 90 V 30 H 75 46 V 16 H 61 90 V 15 H 61 V 1 H 90 V 0 H 61 60 V 0.5 15 H 46 V 0 H 45 V 15 15.5 16 30 H 31 V 0 H 30 15 Z M 16,1 H 30 V 30 30.5 31 45 H 16 V 16 15 Z M 1,16 H 15 V 45 45.5 46 60 H 1 Z M 31,31 H 46 75 V 45 H 61 31 Z M 16,46 H 31 60 V 60 H 46 16 Z M 1,61 H 16 45 V 75 H 31 1 Z"
        />
      </pattern>
      <g v-if="shape === 'curved'"
          :id="this.symbolId"
         transform="translate(-107.22098,-125.9738)">
        <path id="path1"
              :fill="this.fillString"
              :stroke="color"
              fill-opacity="1"
              d="m 110.06242,126.55765 c 1.3519,-0.27493 2.75105,0.18179 3.96875,0.73168 4.27502,1.93056 5.82139,6.28867 4.87938,10.75861 -0.4061,1.92696 -1.60321,3.54271 -1.5662,5.55625 0.0546,2.97157 4.88212,8.4416 0.1262,9.63378 -1.13332,0.28409 -2.54414,0.22677 -3.70396,0.12249 -0.9446,-0.0849 -1.81422,-0.40623 -2.6458,-0.85439 -6.86348,-3.69879 -1.23916,-10.53599 -1.06575,-15.78105 0.10739,-3.24823 -4.97077,-9.15499 0.007,-10.16737"
        />
      </g>

      <g v-if="shape === 'pill'"
          :id="this.symbolId"
          transform="translate(-107.30984,-126.07963)">
        <path
            id="path1"
            :fill="this.fillString"
            :stroke="color"
            fill-opacity="1"
            d="m 119.43123,140.09645 c 0.10443,7.77531 0.40164,13.3742 -5.08742,13.39722 -6.87138,0.0288 -6.57801,-5.59463 -6.50875,-12.13246 0.0755,-7.12385 -0.48434,-14.72854 6.20113,-14.78136 6.18564,-0.0489 5.31707,7.71064 5.39504,13.5166 z"
        />
      </g>
      <g v-if="shape === 'diamond'"
         :id="this.symbolId"
         transform="translate(-107.32726,-125.94269)">
        <path
            id="path1"
            :fill="this.fillString"
            :stroke="color"
            fill-opacity="1"
            d="m 119.43123,140.05205 c -2.17438,6.47777 -4.5315,13.49741 -5.57584,13.39722 -0.74233,-0.0712 -3.46988,-6.88228 -5.97593,-13.0649 2.78347,-7.34586 5.06573,-13.77793 6.15673,-13.80452 1.12351,-0.0274 2.82188,5.97088 5.39504,13.4722 z"
        />
      </g>


    </defs>
  </svg>

</template>
<!--
    <div class="symbol" :style="'background-color: ' + color + ';'">&lt;!&ndash; TODO: move to scoped style &ndash;&gt;
      <img :alt="color + ' | ' + filling + ' | ' + shape" :src="'/shape_' + shape + '_' + filling + '.png'">
    </div>
-->

<script>
export default {
  name: 'SvgComponents',
  props: {
    color: String, /* red | green | blue */
    shape: String, /* diamond | curved | pill */
    filling: String /* solid | pattern | hollow */
  },
  computed: {
    fillString: function () {
      if (this.filling === 'hollow') {
        return 'none';
      } else if (this.filling === 'filled') {
        return this.color;
      }
      return 'url(#pattern18_'+this.color+')';
    },
    symbolId: function () {
      return 'symbol_'+this.color + '_' + this.filling + '_' + this.shape;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.symbol {
  border: none;

  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: width 3s;
  width: auto;
  height: 75%;

  img {
    /*width: 60px;
    height: 120px;*/
    height: 100%;
    width: auto;
    /*float: left;*/
    transition: width 3s;

    svg path {
      fill: blue;
    }
  }
}
</style>
